module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-11.fb41143a.png";